import { FcOk } from "react-icons/fc";
import styled from "styled-components";
import PricingPlanQuestionsBox from "./PricingPlanQuestionsBox";

const PricingPlanCard = ({ plan, setPlanType, openReserveModal }) => {
  const isSecurePlanType = plan.type.toLowerCase() === "secure";
  const isOptimalPlanType = plan.type.toLowerCase() === "optimal";
  return (
    <Wrapper
      $bgColor={plan.colors.body}
      className="rounded-4 pb-lg-5 mx-auto mx-lg-0"
    >
      <div className="h-100 d-flex flex-column rounded-4 position-relative">
        {isSecurePlanType && (
          <div className="bg-light-orange br-10 px-4 text-white font-15 font-weight-bold popular position-absolute">
            Popular
          </div>
        )}
        <div
          className="rounded-top-4 d-flex justify-content-center align-items-center gap-2 px-4 py-2"
          style={{ backgroundColor: plan.colors.header }}
        >
          <img src={plan.planImage} alt={plan.title} className="width-50" />
          <h6 className="font-weight-bold font-25 text-white mt-2">
            {plan.type} Rental Plan
          </h6>
        </div>
        <div className="h-100 p-4 mx-lg-4 my-lg-2 d-flex flex-column gap-4 text-left">
          <div className="">
            <h6 className="font-weight-bold font-25 text-light-black">
              {plan.title}
            </h6>
            <p className="m-0 text-light-black">{plan.subtitle}</p>
          </div>
          <div
            style={{ backgroundColor: plan.colors.priceBox }}
            className="p-4 rounded-4 d-flex flex-column gap-2"
          >
            <h6 className="font-weight-bold font-25 text-light-black">
              You earn {isOptimalPlanType && "up to"}
            </h6>
            <h6 className="font-weight-bold font-50 text-light-black">
              {plan.price.amount.toLocaleString()}{" "}
              <span className="font-20">KES</span>
            </h6>
            <p className="font-weight-bold text-success">
              {plan.price.message}
            </p>
          </div>
          <div className="d-flex flex-column gap-2 gap-lg-4">
            {plan.features.map((feature, index) => (
              <div key={index} className="d-flex  gap-2">
                <FcOk className="font-25" />
                <p key={index} className="text-light-black m-0">
                  {feature}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="p-3 p-lg-4 pb-5 mx-lg-4 my-lg-2">
          <button
            type="button"
            onClick={() => {
              setPlanType(plan.type);
              openReserveModal();
            }}
            className="w-100 btn action text-white font-17"
          >
            {isSecurePlanType ? "Choose Secure" : "Choose Optimal"}
          </button>
        </div>
      </div>
      <div className="d-block d-lg-none">
        <PricingPlanQuestionsBox plan={plan} />
      </div>
    </Wrapper>
  );
};

export default PricingPlanCard;

const Wrapper = styled.div`
  background: ${(props) => props.$bgColor};
  outline: 0.3px solid #7fb5fcff;
  width: 100%;
  max-width: 485px;

  button.action {
    background-color: var(--green);
    padding: 0.5rem 1rem;
    border-radius: 10px;
  }
  .popular {
    background: #fcad38;
    top: -20px;
    right: 25px;
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
  }
`;
